import { useEffect } from "react";
import get from "lodash/get";
import { getMonth, getDate, getYear, differenceInHours, differenceInMinutes, differenceInSeconds } from "date-fns";

import {
  ENG_GOOGLE_PLAYSTORE,
  ENG_APPLE_PLAYSTORE,
  BN_APPLE_PLAYSTORE,
  BN_GOOGLE_PLAYSTORE,
  NA_GOOGLE_PLAYSTORE,
  NA_APPLE_PLAYSTORE,
} from "./constant";
import { parseUrl } from "query-string";
import { find } from "lodash";
import { staticTexts } from "./Translate";
import { format, utcToZonedTime } from "date-fns-tz";

export const getSlug = (collection, sections = [], domainSlug, navigateTo) => {
  let slug = "#";

  if (navigateTo) {
    if (sections.find((item) => item.slug === navigateTo)) {
      return `/${navigateTo}`;
    }
  }

  if (collection && collection.slug) {
    const metadata = Object.keys(get(collection, ["metadata"], {}));
    const isSection = metadata.indexOf("section") !== -1;

    if (sections && sections.length > 0 && isSection) {
      const sectionId = collection.metadata.section[0].id;
      const section = sections.find((item) => item.id === sectionId);

      if (section && section["parent-id"] && !domainSlug) {
        const parentSection = sections.find((item) => item.id === section["parent-id"]);

        if (parentSection && !domainSlug) {
          slug = `/${parentSection.slug}/${section.slug}`;
        }
      } else if ((section && !section["parent-id"]) || (section && domainSlug)) {
        slug = `/${section.slug}`;
      }
    } else {
      slug = `/collection/${collection.slug}`;
    }
  }

  return slug;
};

export const getCollectionName = (collection, navigateToTitle) => {
  if (navigateToTitle) {
    return navigateToTitle;
  }
  const collectionName = get(collection, ["name"], "");
  return collectionName;
};

export const getStoryHeadline = (story) => {
  return get(story, ["alternative", "home", "default", "headline"]) || story.headline;
};

export const getStoryData = (story, isAlternativeImageFirst = true) => {
  let storyData = {
    imageS3Key: null,
  };

  if (!story) {
    return storyData;
  }

  if (isAlternativeImageFirst) {
    storyData = getAlternativeData(story);
    if (!storyData.imageS3Key) {
      storyData = getMainData(story);
    }
  } else {
    storyData = getMainData(story);
    if (!storyData.imageS3Key) {
      storyData = getAlternativeData(story);
    }
  }
  return storyData;
};

const getAlternativeData = (story) => {
  const storyData = {};
  storyData.headline = getStoryHeadline(story);
  storyData.imageS3Key = get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], null);
  storyData.imageCaption =
    get(story, ["alternative", "home", "default", "hero-image", "hero-image-caption"]) || storyData.headline;

  storyData.imageAttribution = get(
    story,
    ["alternative", "home", "default", "hero-image", "hero-image-attribution"],
    null
  );

  storyData.imageMetadata = get(story, ["alternative", "home", "default", "hero-image", "hero-image-metadata"], null);
  return storyData;
};

const getMainData = (story) => {
  const storyData = {};
  storyData.headline = getStoryHeadline(story);
  storyData.subHeadline = story.subheadline || null;
  storyData.imageS3Key = get(story, ["hero-image-s3-key"], null);
  storyData.imageCaption = get(story, ["hero-image-caption"]) || storyData.headline;
  storyData.imageMetadata = story["hero-image-metadata"];
  storyData.imageAttribution = get(story, ["hero-image-attribution"], null);
  return storyData;
};

/**
 * Validate the Email
 */
export function isValidEmail(email) {
  // eslint-disable-next-line max-len
  const re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
  if (!re.test(email)) return false;
  if (email.length > 150 || email.length < 6) return false;
  return true;
}

export const getDeviceType = () => {
  if (global.deviceWidth < 876) {
    return "mobile";
  } else if (global.deviceWidth > 875 && global.deviceWidth < 1264) {
    return "tablet";
  }

  return "desktop";
};

/**
 * Given english number returns a bangla number
 */
export const toBanglaNum = (value) => {
  const numbersObj = {
    0: "০",
    1: "১",
    2: "২",
    3: "৩",
    4: "৪",
    5: "৫",
    6: "৬",
    7: "৭",
    8: "৮",
    9: "৯",
    ".": ".",
    "-": "-",
  };

  if (isNaN(parseFloat(value)) || isNaN(value - 0)) {
    return "Invalid input type";
  }

  let str = "";

  return (
    value
      .toString()
      .split("")
      .forEach((num) => (str += numbersObj[num])),
    str
  );
};

export const toBanglaMonth = (value) => {
  const monthsObj = {
    1: "জানুয়ারি",
    2: "ফেব্রুয়ারি",
    3: "মার্চ",
    4: "এপ্রিল",
    5: "মে",
    6: "জুন",
    7: "জুলাই",
    8: "আগস্ট",
    9: "সেপ্টেম্বর",
    10: "অক্টোবর",
    11: "নভেম্বর",
    12: "ডিসেম্বর",
  };

  return monthsObj[value];
};

export const toEngMonth = (value) => {
  const monthsObj = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
  };

  return monthsObj[value];
};

export const getBanglaWeekName = (name) => {
  const weekObj = {
    Sunday: "রোববার",
    Monday: "সোমবার",
    Tuesday: "মঙ্গলবার",
    Wednesday: "বুধবার",
    Thursday: "বৃহস্পতিবার",
    Friday: "শুক্রবার",
    Saturday: "শনিবার",
  };
  return weekObj[name];
};

export const getBanglaWeekNameShort = (name) => {
  const weekObj = {
    Sun: "রোববার",
    Mon: "সোমবার",
    Tue: "মঙ্গলবার",
    Wed: "বুধবার",
    Thu: "বৃহস্পতিবার",
    Fri: "শুক্রবার",
    Sat: "শনিবার",
  };
  return weekObj[name];
};

export const getEnglishWeekName = (name) => {
  const weekObj = {
    Sun: "Sunday",
    Mon: "Monday",
    Tue: "Tuesday",
    Wed: "Wednesday",
    Thu: "Thursday",
    Fri: "Friday",
    Sat: "Saturday",
  };
  return weekObj[name];
};

/**
 * Get the date for the header in Bangla
 */

export const getDateFromUtils = (lang) => {
  const currentDate = new Date();
  const dateArray = new Date().toDateString().split(" ");
  const month = currentDate.getMonth() + 1;
  if (lang === "bn") {
    return `${getBanglaWeekNameShort(dateArray[0])}, ${toBanglaNum(dateArray[2])} ${toBanglaMonth(month)} ${toBanglaNum(
      dateArray[3]
    )}`;
  } else {
    return `${getEnglishWeekName(dateArray[0])}, ${dateArray[2]} ${toEngMonth(month)} ${dateArray[3]}`;
  }
};

export const getStoryDate = (publishedTime, lang, pageType, storyType) => {
  const hourDifference = differenceInHours(new Date(), new Date(publishedTime));
  const minuteDifference = differenceInMinutes(new Date(), new Date(publishedTime));
  const secondsDifference = differenceInSeconds(new Date(), new Date(publishedTime));

  const getTime = () => {
    const completeStoryDate = new Date(publishedTime).toDateString();
    const completeStoryTime = new Date(publishedTime).toTimeString();
    const completeStoryDateSplit = completeStoryDate.split(" ");
    const completeStoryTimeSplit = completeStoryTime.split(":");
    const dateArray = completeStoryDateSplit[2];
    const storyMonthAndDay = completeStoryDateSplit[1];
    const storyYearAndMonth = completeStoryDateSplit[3];
    const storyHours = completeStoryTimeSplit[0];
    const storyMinutes = completeStoryTimeSplit[1];
    if (lang === "en") {
      return `${dateArray} ${storyMonthAndDay} ${storyYearAndMonth}, ${storyHours}:${storyMinutes}`;
    } else {
      const month = new Date(publishedTime).getMonth() + 1;
      if (storyType === "live-blog") {
        return `${toBanglaNum(storyHours)}: ${toBanglaNum(storyMinutes)}, ${toBanglaMonth(month)} ${toBanglaNum(
          dateArray
        )}`;
      } else {
        return `${toBanglaNum(dateArray)} ${toBanglaMonth(month)} ${toBanglaNum(storyYearAndMonth)}, ${toBanglaNum(
          storyHours
        )}: ${toBanglaNum(storyMinutes)}`;
      }
    }
  };

  if (pageType === "story-page") {
    return getTime();
  }

  if (secondsDifference < 60) {
    return staticTexts(lang).fewMomentsAgo;
  } else if (secondsDifference >= 60 && secondsDifference < 119) {
    return staticTexts(lang).oneMinuteAgo;
  } else if (secondsDifference >= 120 && minuteDifference < 59) {
    return lang === "bn"
      ? `${toBanglaNum(minuteDifference)} ${staticTexts(lang).minutesAgo}`
      : `${minuteDifference} ${staticTexts(lang).minutesAgo}`;
  } else if (minuteDifference >= 60 && hourDifference < 2) {
    return staticTexts(lang).oneHourAgo;
  } else if (hourDifference >= 2 && hourDifference < 24) {
    return lang === "bn"
      ? `${toBanglaNum(hourDifference)} ${staticTexts(lang).hoursAgo}`
      : `${hourDifference} ${staticTexts(lang).hoursAgo}`;
  } else return getTime();
};

export const getDomainSectionInfo = (domainSlug, sections) => {
  return sections.find((item) => item["domain-slug"] === domainSlug && item["parent-id"] === null);
};

const sectionObjects = ({ parentSectionObj = {}, currentSectionObj = {}, childSections = [] }) => {
  const { "display-name": parentDisplayName, "section-url": parentSectionUrl } = parentSectionObj;

  const {
    "display-name": currentDisplayName,
    "section-url": currentSectionUrl,
    "parent-id": currentSectionParentId,
  } = currentSectionObj;
  const requiredObj = {};

  requiredObj.parentSection = parentDisplayName || null;
  requiredObj.parentSectionUrl = parentSectionUrl || null;
  requiredObj.currentSection = currentDisplayName || null;
  requiredObj.parentSectionId = currentSectionParentId || null;
  requiredObj.currentSectionUrl = currentSectionUrl || null;
  requiredObj.childSections = childSections;

  return requiredObj;
};

export const getSectionsDataForHeader = (sections, domainSlug, currentSection = {}, domainSectionObj) => {
  const currentSectionObj = sections.find((item) => item.id === currentSection[0].id);
  if (currentSectionObj["parent-id"]) {
    const parentSectionObj = sections.find((item) => item.id === currentSectionObj["parent-id"]);
    const siblingSections = sections.filter((item) => item["parent-id"] === parentSectionObj.id);

    let childSections = [];

    if (!domainSlug || domainSectionObj.id !== currentSectionObj["parent-id"]) {
      childSections = siblingSections;
    } else {
      childSections = sections.filter((item) => item["parent-id"] === currentSectionObj.id);
    }

    return sectionObjects({ parentSectionObj, currentSectionObj, childSections });
  } else {
    const childSections = sections.filter((item) => item["parent-id"] === currentSectionObj.id);
    return sectionObjects({ currentSectionObj, childSections });
  }
};

export const showSectionWithMenuItems = (sectionDataForHeader) => {
  const currentSectionData = sectionDataForHeader.childSections.find(
    (children) => children.name === sectionDataForHeader.currentSection
  );
  const colorCode = get(currentSectionData, ["data", "color"], "#FFFFFF");
  const hideColorCode = "#000001";
  return colorCode !== hideColorCode;
};

export const getBanglaDate = (value) => {
  const monthname = toBanglaMonth(getMonth(value) + 1);
  const date = toBanglaNum(getDate(value));
  const year = toBanglaNum(getYear(value));

  return `${date} ${monthname} ${year}`;
};

export const getEngDate = (value, type = "default") => {
  let monthName = getMonth(value) + 1;

  if (type === "monthname") {
    monthName = toEngMonth(monthName);
  }

  const date = getDate(value);
  const year = getYear(value);

  return `${date} ${monthName} ${year}`;
};

export const useOuterClickNotifier = (onOuterClick, innerRef) => {
  useEffect(
    () => {
      // only add listener, if the element exists
      if (innerRef.current) {
        document.addEventListener("click", handleClick);
      }

      // unmount previous first in case input has changed
      return () => document.removeEventListener("click", handleClick);

      function handleClick(e) {
        innerRef.current && !innerRef.current.contains(e.target) && onOuterClick(e);
      }
    },
    [onOuterClick, innerRef] // invoke again, if inputs has changed
  );
};

export const getKeyHighlights = (cards) => {
  return cards && cards.length > 0
    ? cards
        .filter((card) => get(card, ["metadata", "attributes", "key-event"], false))
        .map((card) => ({
          title: card["story-elements"].find((element) => element.type === "title").text,
          card,
        }))
    : null;
};

export const getAuthorName = (story) => {
  const authorDisplayName = get(story, ["metadata", "story-attributes", "author-display-name", "0"], null);
  const authorObj = get(story, ["authors", "0"], null);
  const authorName = (authorObj && authorObj.name) || story["author-name"];
  return authorDisplayName || authorName;
};

export const getExcerpt = (story, maxLength = 200) => {
  let excerpt = get(story, ["metadata", "excerpt"], get(story, ["metadata", "summary"]));

  if (excerpt && excerpt.length > maxLength) {
    const extractString = excerpt.substr(0, maxLength);
    excerpt = extractString.substr(0, Math.min(extractString.length, extractString.lastIndexOf(" "))).concat(" ...");
  }
  return excerpt;
};

export const getHeadline = (story) => {
  if (!story) {
    return null;
  }
  const alternateHeadline = get(story, ["alternative", "home", "default", "headline"], null);
  if (!alternateHeadline) {
    return story.headline;
  }
  return alternateHeadline;
};

// Validation rules for the password
export const validatePassword = (str, type = "") => {
  if (!str) {
    return type === "confirm-password" ? "Please confirm your password" : "Please enter password";
  } else if (str.length < 8) {
    return "Password too short";
  } else if (str.search(/\d/) === -1 || str.search(/[a-zA-Z]/) === -1) {
    return "Password you have entered is not strong enough. Please ensure your password uses combination of letters & numbers and is minimum 8 charcaters long";
  }

  return null; // Indicates password is valid
};

// Process the required response in appropriate format

export const processComments = (data) => {
  const list = [];

  data.forEach((item) => {
    const headline = get(item, ["attributes", "page", "headline"], null);
    const statusOfComment = get(item, ["attributes", "status"], "");

    if (headline) {
      const optionList = get(item, ["attributes", "body", "ops"], []);
      const url = get(item, ["attributes", "page", "url"], "");
      const commentList = [];

      optionList.forEach((option) => {
        if (typeof option.insert === "string") {
          commentList.push({
            message: option.insert,
            isMentioned: false,
          });
        } else {
          if (option.insert && option.insert.mentions) {
            commentList.push({
              link: get(option, ["attributes", "link"], ""),
              isMentioned: true,
            });
          }
        }
      });

      list.push({
        comments: commentList,
        createdAt: item.attributes.created_at,
        headline,
        url,
        statusOfComment,
      });
    }
  });

  return list;
};

export const headerLevelLogo = (pageType) => {
  return pageType === "home-page" ? 1 : 2;
  // switch (pageType) {
  //   case "home-page":
  //     return 1;
  //   case "story-page":
  //     return 2;
  //   case "section-page":
  //     return 2;
  //   case "notification-page":
  //     return 2;
  //   case "tag-page":
  //     return 2;
  //   case "author-page":
  //     return 2;
  //   case "collection-page":
  //     return 2;
  //   case "static-page":
  //     return 2;
  //   case "search-page":
  //     return 2;
  //   default:
  //     return 1;
  // }
};

export const appDownloadLinks = (lang, platform, domainSlug) => {
  if (lang === "en") {
    return platform === "google" ? ENG_GOOGLE_PLAYSTORE : ENG_APPLE_PLAYSTORE;
  } else if (domainSlug === "northamerica") {
    return platform === "google" ? NA_GOOGLE_PLAYSTORE : NA_APPLE_PLAYSTORE;
  } else {
    return platform === "google" ? BN_GOOGLE_PLAYSTORE : BN_APPLE_PLAYSTORE;
  }
};

export const getCurrentSite = (currentPath) => {
  if (currentPath) {
    if (
      currentPath.includes("www.prothomalo.com") ||
      currentPath.includes("beta.prothomalo.com") ||
      currentPath.includes("prothomalo.qtstage.io")
    ) {
      return "bn";
    } else if (currentPath.includes("kia") || currentPath.includes("kishoralo")) {
      return "kishoralo";
    } else if (currentPath.includes("bs") || currentPath.includes("bondhushava")) {
      return "bondhushava";
    } else if (currentPath.includes("pc") || currentPath.includes("protichinta")) {
      return "protichinta";
    } else if (currentPath.includes("bc") || currentPath.includes("bigganchinta")) {
      return "bigganchinta";
    } else if (currentPath.includes("trust")) {
      return "trust";
    } else if (currentPath.includes("nagorik")) {
      return "nagorik-sangbad";
    } else if (currentPath.includes("northamerica") || currentPath.includes("na")) {
      return "northamerica";
    } else if (
      currentPath.includes("en.prothomalo.qtstage.io") ||
      currentPath.includes("en-beta.prothomalo.com") ||
      currentPath.includes("en.prothomalo.com")
    ) {
      return "en";
    } else {
      return "bn";
    }
  } else return "bn";
};

export const getHeaderUrl = (currentPath) => {
  const params = parseUrl(currentPath);
  const redirectUrl = get(params, ["query", "redirect-url"], "https://www.prothomalo.com");
  const getRedirectUrl = new URL(redirectUrl);
  return getRedirectUrl.origin;
};

export const fontVariation = (type, elements, customGalleryElements, lang) => {
  const divisableNumber = lang === "en" ? 8 : 10;
  const incrementer = lang === "en" ? 0.25 : 0.2;

  const processFontStyle = (type, element) => {
    return (element.style.fontSize =
      type === "add"
        ? parseFloat(getComputedStyle(element).fontSize) / divisableNumber + incrementer + "rem"
        : parseFloat(getComputedStyle(element).fontSize) / divisableNumber - incrementer + "rem");
  };

  const computeStyles = (elements) => {
    Array.from(elements).forEach((element) => processFontStyle(type, element));
  };

  computeStyles(elements);
  computeStyles(customGalleryElements);
};

export const getDomainHostUrl = (domainSlug, domains) => {
  if (domainSlug && domains.length) {
    const domainObj = domains.find((item) => item.slug === domainSlug);

    return domainObj && domainObj["host-url"] ? domainObj["host-url"] : "";
  }

  return "";
};

export const checkCurrentStoryTagForSpecialCampaign = (story, currentTag, headlineSpecialColor) => {
  const showCurrentTag = get(story, ["tags"], null);
  const matchCurrentTag = showCurrentTag.find((item) => item.name === currentTag);
  if (matchCurrentTag) {
    return headlineSpecialColor;
  } else {
    return "";
  }
};

export const currentMeta = (allSections, currentSectionId) => {
  for (let i = 0; i < allSections.length; i++) {
    if (parseInt(allSections[i]["owner-id"]) === parseInt(currentSectionId)) {
      return allSections[i].data;
    }
  }
};

export const generateDIstrictNewsSlug = (districtSlug, divisionSlug, subDistrictSlug) => {
  if (subDistrictSlug) {
    return `/${divisionSlug}/${districtSlug}/${subDistrictSlug}`;
  } else if (districtSlug) {
    return `/${divisionSlug}/${districtSlug}`;
  } else if (divisionSlug) {
    return `/${divisionSlug}`;
  } else return "";
};

export const getBirthDate = (dob) => {
  if (dob && dob !== "-") {
    const parts = dob.split("-");
    return `${parts[0]}/${toEngMonth(parts[1]).substring(0, 3)}/${parts[2]}`;
  }
  return null;
};

export const trimLastSlash = (pageUrl) => {
  return pageUrl[pageUrl.length - 1] === "/" ? pageUrl.slice(0, -1) : pageUrl;
};

export const completeUrlSetter = (menuList, sections) => {
  menuList.children.forEach((item) => {
    switch (item["item-type"]) {
      case "tag":
        item.completeUrl = item["tag-slug"] ? `/topic/${item["tag-slug"]}` : "/#";
        break;
      case "entity":
        item.completeUrl = item["entity-slug"] ? `/topic/${item["entity-slug"]}` : "/#";
        break;
      case "link":
        item.completeUrl = get(item, ["data", "link"]) || "/#";
        item.isExternalLink = true;
        break;
      case "section":
        item.completeUrl = findCompleteUrl(item, sections);
        break;
      default:
        item.completeUrl = "/#";
        break;
    }
  });
  return menuList;
};

const findCompleteUrl = (menutItem, sections) => {
  const sectionObject = find(sections, function (item) {
    return item.id === menutItem["item-id"];
  });
  if (!sectionObject) {
    return "/#";
  }
  return sectionObject["section-url"];
};

export const getMember = (member) => {
  return !member["avatar-s3-key"] && !member["avatar-url"]
    ? {
        ...member,
        "avatar-url":
          "https://images.prothomalo.com/prothomalo-bangla/2020-10/c679f2ab-c844-48c8-84a3-182f1152630c/member_avatar.png",
      }
    : member;
};

export const getContinueToText = (currentPath) => {
  if (currentPath) {
    if (currentPath.includes("kia") || currentPath.includes("kishoralo")) {
      return "Kishor alo";
    } else if (currentPath.includes("bs") || currentPath.includes("bondhushava")) {
      return "Bondhushava";
    } else if (currentPath.includes("pc") || currentPath.includes("protichinta")) {
      return "Protichinta";
    } else if (currentPath.includes("bc") || currentPath.includes("bigganchinta")) {
      return "Bigganchinta";
    } else if (currentPath.includes("trust")) {
      return "Trust";
    } else if (currentPath.includes("nagorik")) {
      return "Nagorik Sangbad";
    } else if (currentPath.includes("northamerica") || currentPath.includes("na")) {
      return "North America";
    } else if (
      currentPath.includes("en-uat.prothomalo.qtstage.io") ||
      currentPath.includes("en.prothomalo.qtstage.io") ||
      currentPath.includes("en-beta.prothomalo.com") ||
      currentPath.includes("en.prothomalo.com")
    ) {
      return "Prothom Alo English";
    } else {
      return "Prothom Alo";
    }
  } else return "Prothom Alo";
};
// NTG
export const googleTagEvents = (eventName, articleTitle, value) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    if (eventName === "login" || eventName === "registration") {
      window.dataLayer.push({
        event: eventName,
      });
    } else if (eventName === "push-notification-click") {
      window.dataLayer.push({
        event: eventName,
        article_title: articleTitle,
      });
    } else if (eventName === "article-milestone") {
      window.dataLayer.push({
        event: eventName,
        article_title: articleTitle,
        scroll_measure_percent: `${value}%`,
        scroll_measure_value: value,
      });
    } else if (eventName === "social-share") {
      window.dataLayer.push({
        event: eventName,
        social_platform: articleTitle,
      });
    }
  }
};

export function stripMillisecondsFromTime(date, timezone) {
  const toReturn = date.toJSON();
  if (!toReturn) {
    return toReturn;
  }
  const zonedTime = timezone && utcToZonedTime(date, timezone);
  const formatZonedTime = zonedTime && format(zonedTime, "yyyy-MM-dd'T'HH:mm:ssXXX", { timeZone: timezone });
  const formatToReturn = toReturn.split(".")[0] + "Z";
  return timezone ? formatZonedTime : formatToReturn;
}
